import { Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PrivilegeGuard  {
  constructor(public authService: AuthService) {}

  canLoad(route: Route): boolean {
    const expectedPrivilege = route.data.expectedPrivilege;

    if (!this.authService.hasPrivilege(expectedPrivilege)) {
      return false;
    }
    return true;
  }
}
